import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import { LaIconEditorTab } from "^/Components/ScrivitoExtensions/LaIconEditorTab";
import PageObjIcon from "../../assets/images/page_obj.svg";
import {
  defaultPageInitialContent,
  defaultPageProperties,
} from "../_defaultPageEditingConfig";
import {
  metadataInitialContent,
  metadataPropertiesGroup,
  socialCardsPropertiesGroup,
} from "../_metadataEditingConfig";

Scrivito.provideEditingConfig("Page", {
  title: "Page",
  thumbnail: PageObjIcon,

  attributes: localizeAttrList(
    [
      ...defaultPageProperties,
      ...metadataPropertiesGroup.properties,
      "isNavigationPage",
    ],
    "Page"
  ),
  properties: [...defaultPageProperties, "isNavigationPage", "logo"],
  propertiesGroups: [
    {
      title: "LA Icon",
      component: ({ obj }) => (
        <LaIconEditorTab obj={obj} attribute="navigationIcon" />
      ),
      key: "laIconEditorTab",
    },
    socialCardsPropertiesGroup,
    metadataPropertiesGroup,
  ],
  initialContent: {
    isNavigationPage: "no",
    ...defaultPageInitialContent,
    ...metadataInitialContent,
  },
  validations: [
    [
      "title",
      (title) => {
        if (title === "" || title === "New Page") {
          return "Title can not be empty or set to its default value. Set a proper Title for this Page";
        }
        return null;
      },
    ],
    [
      (obj) => {
        if (!obj.path) {
          return "Path can not be empty. This Page is on root level and not in the Navigation structure. Move or delete this Object.";
        }
        return null;
      },
    ],
  ],
});
